import {createApp} from 'vue'
import Buefy from 'buefy'
import {buefyConfig, keepalive, reloadPageIfCached} from "./ts/utils.js";
import SignIn from "./pages/SignIn.vue";

// EAUTH2-232
reloadPageIfCached()

const app = createApp(SignIn);

//@ts-ignore
app.use(Buefy, buefyConfig)
app.mount('#app')

keepalive(false)
